import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from "react";
const MermaidReal = lazy(() => import("./MermaidReal.js"));
export const Mermaid = ({ plan }) => {
    return (_jsx(Suspense, { fallback: _jsx("div", { children: "Mermaid hasn't (yet) loaded, so we cannot render plan diagrams" }), children: _jsx(MermaidReal, { plan: plan }) }));
};
//# sourceMappingURL=Mermaid.js.map